import { createFileRoute } from '@tanstack/react-router';

import { PageEditPage, pageQueryOptions } from '@/features/pages';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/pages/$pageId')({
  staticData: { tours: ['content.page-editor'] },
  loader: async ({ context, params }) => {
    const page = await context.queryClient.query({
      ...pageQueryOptions(params.storeId, params.pageId),
      staleTime: 'static',
    });
    return { crumb: page.title };
  },
  component: PageEditPage,
});
